import React from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, FileText, Trash2, X } from 'lucide-react';

const ConfirmSnippetDeleteModal = ({ isOpen, onClose, onConfirm, snippetName, isDeleting = false }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[10010] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0, scale: 0.96, y: 8 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 8 }}
            className="relative w-full max-w-md rounded-xl border border-border-color bg-surface shadow-xl"
          >
            <div className="flex items-center justify-between border-b border-border-color px-5 py-4">
              <div className="flex items-center gap-2.5">
                <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-red-500/10 text-red-300">
                  <AlertTriangle size={18} />
                </div>
                <div>
                  <h2 className="text-base font-semibold text-on-surface">Delete Snippet</h2>
                  <p className="text-[12px] text-on-surface-dim">Remove this saved scratch note.</p>
                </div>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="rounded-full p-1 text-on-surface-dim transition-colors hover:bg-surface-dark hover:text-on-surface"
                aria-label="Close"
              >
                <X size={18} />
              </button>
            </div>

            <div className="space-y-3 px-5 py-4">
              <div className="rounded-lg border border-border-color bg-background-dark/60 px-3 py-3">
                <div className="flex items-start gap-2.5">
                  <FileText size={16} className="mt-0.5 text-primary" />
                  <div>
                    <p className="text-[12px] font-medium uppercase tracking-[0.12em] text-on-surface-dim">Snippet</p>
                    <p className="mt-1 text-sm text-on-surface">{snippetName || 'Untitled snippet'}</p>
                  </div>
                </div>
              </div>
              <p className="text-sm text-on-surface-dim">This removes the snippet from your global scratch library. This action cannot be undone.</p>
            </div>

            <div className="flex items-center justify-end gap-3 border-t border-border-color px-5 py-4">
              <button
                type="button"
                onClick={onClose}
                disabled={isDeleting}
                className="rounded-md bg-surface-dark px-4 py-2 text-sm font-semibold text-on-surface transition-colors hover:bg-surface-raised disabled:cursor-not-allowed disabled:opacity-60"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onConfirm}
                disabled={isDeleting}
                className="inline-flex items-center gap-2 rounded-md bg-red-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-400 disabled:cursor-not-allowed disabled:opacity-60"
              >
                <Trash2 size={14} />
                {isDeleting ? 'Deleting...' : 'Delete Snippet'}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default ConfirmSnippetDeleteModal;